import {
  COLLECTION_ADD,
  COLLECTION_SUCCESS,
  COLLECTION_FAIL,
  GET_COLLECTION_LISTING,
  GET_COLLECTION_LISTING_SUCCESS,
  GET_COLLECTION_LISTING_FAILED,
  COLLECTION_EDIT,
  COLLECTION_EDIT_SUCCESS,
  COLLECTION_EDIT_FAIL,
  COLLECTION_UPDATE,
  COLLECTION_UPDATE_SUCCESS,
  COLLECTION_UPDATE_FAIL,
  COLLECTION_DELETE,
  COLLECTION_DELETE_SUCCESS,
  COLLECTION_DELETE_FAIL,
  EXPORTCOLLECTIONCATALOG_DOWNLOAD,
  EXPORTCOLLECTIONCATALOG_DOWNLOAD_SUCCESS,
  EXPORTCOLLECTIONCATALOG_DOWNLOAD_FAIL,
  COLLECTION_COPY,
  COLLECTION_COPY_SUCCESS,
  COLLECTION_COPY_FAIL,
  ADMINEXPORTDOWNLOAD_PROGRESS,
  ADMINEXPORTDOWNLOAD_PROGRESS_SUCCESS,
  ADMINEXPORTDOWNLOAD_PROGRESS_FAIL,
  ADMIN_ADD_MORE_TO_COLLECTION,
  ADMIN_ADD_MORE_TO_COLLECTION_SUCCESS,
  ADMIN_ADD_MORE_TO_COLLECTION_FAIL,
  ADMIN_ADD_MORE_TO_COLLECTION_UPDATE,
  ADMIN_ADD_MORE_TO_COLLECTION_UPDATE_SUCCESS,
  ADMIN_ADD_MORE_TO_COLLECTION_UPDATE_FAIL,
  GET_PRODUCTS_FOR_ADD_COLLECTION,
  GET_PRODUCTS_FOR_ADD_COLLECTION_SUCCESS,
  GET_PRODUCTS_FOR_ADD_COLLECTION_FAIL,
  GET_PRODUCT_OFFER_FOR_ADD_COLLECTION,
  GET_PRODUCT_OFFER_FOR_ADD_COLLECTION_SUCCESS,
  GET_PRODUCTS_OFFER_FOR_ADD_COLLECTION_FAIL,
  REFRESH_COLLECTION_COUNT,
  REFRESH_COLLECTION_COUNT_SUCCESS,
  REFRESH_COLLECTION_COUNT_FAIL,
} from "./actionTypes"

const initialState = {
  error: null,
  msg: null,
  loading: false,
  collection: null,
  collectionEdit: null,
  collectionUpdate: null,
  collectionDelete: null,
  exportCollection: null,
  collectionCopy: null,
  adminExportDownloadProgress: null,
  collectionAddMore: null,
  addMoreUpdateDetails: null,
  productsForAddCollection: null,
  productsOfferForAddCollection: null,
}

export const collection = (state = initialState, action) => {
  switch (action.type) {
    case COLLECTION_ADD:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collection: action.payload,
      }
      break
    case COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collectionEdit: null,
        collectionUpdate: null,
        collectionDelete: null,
        exportCollection: null,
        collectionCopy: null,
        collectionAddMore: null,
        collection: action.payload,
      }
      break
    case COLLECTION_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        collectionEdit: null,
        collectionUpdate: null,
        collectionDelete: null,
        exportCollection: null,
        collectionCopy: null,
        collectionAddMore: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case GET_COLLECTION_LISTING:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionEdit: null,
        collectionUpdate: null,
        collectionDelete: null,
        exportCollection: null,
        collectionCopy: null,
        collectionAddMore: null,
        collection: action.payload,
      }
      break
    case GET_COLLECTION_LISTING_SUCCESS:
      state = {
        ...state,
        error: null,
        msg: null,
        loading: false,
        collectionAddMore: null,
        collection: action.payload,
      }
      break
    case GET_COLLECTION_LISTING_FAILED:
      state = {
        ...state,
        loading: false,
        msg: null,
        collectionAddMore: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case COLLECTION_EDIT:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionEdit: action.payload,
      }
      break
    case COLLECTION_EDIT_SUCCESS:
      if (state === null || state.collection.length === 0) {
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          collection: [...state.collection, action.payload],
        }
      } else {
        state = {
          ...state,
          loading: false,
          msg: null,
          collection: state.collection.map(i =>
            i.id === action.payload.id ? action.payload : i
          ),
        }
      }
      break
    case COLLECTION_EDIT_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case COLLECTION_UPDATE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionUpdate: action.payload,
      }
      break
    case COLLECTION_UPDATE_SUCCESS:
      state = { ...state, msg: null, error: null, loading: false }
      break
    case COLLECTION_UPDATE_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case COLLECTION_DELETE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionDelete: action.payload,
      }
      break
    case COLLECTION_DELETE_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collection: state.collection.filter(collection => {
          return collection.id !== action.payload.id
        }),
      }
      break
    case COLLECTION_DELETE_FAIL:
      return {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case EXPORTCOLLECTIONCATALOG_DOWNLOAD:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        exportCollection: action.payload,
      }
      break
    case EXPORTCOLLECTIONCATALOG_DOWNLOAD_SUCCESS:
      state = {
        ...state,
        error: null,
        msg: null,
        loading: false,
        exportCollection: action.payload,
      }
      break
    case EXPORTCOLLECTIONCATALOG_DOWNLOAD_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case COLLECTION_COPY:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionCopy: action.payload,
      }
      break
    case COLLECTION_COPY_SUCCESS:
      let newcol = [...state.collection, action.payload]
      newcol = newcol.sort(function (a, b) {
        return b.id - a.id || b.id.localeCompare(a.id)
      })
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collection: newcol,
        collectionCopy: null,
      }
      break
    case COLLECTION_COPY_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case ADMINEXPORTDOWNLOAD_PROGRESS:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        adminExportDownloadProgress: action.payload,
      }
      break
    case ADMINEXPORTDOWNLOAD_PROGRESS_SUCCESS:
      state = {
        ...state,
        error: null,
        loading: false,
        msg: null,
        adminExportDownloadProgress: action.payload,
      }
      break
    case ADMINEXPORTDOWNLOAD_PROGRESS_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case ADMIN_ADD_MORE_TO_COLLECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionAddMore: action.payload,
      }
      break
    case ADMIN_ADD_MORE_TO_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collectionAddMore: action.payload,
      }
      break
    case ADMIN_ADD_MORE_TO_COLLECTION_FAIL:
      return {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case ADMIN_ADD_MORE_TO_COLLECTION_UPDATE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        addMoreUpdateDetails: action.payload,
      }
      break
    case ADMIN_ADD_MORE_TO_COLLECTION_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        addMoreUpdateDetails: null,
      }
      break
    case ADMIN_ADD_MORE_TO_COLLECTION_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case GET_PRODUCTS_FOR_ADD_COLLECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productsForAddCollection: action.payload,
      }
      break
    case GET_PRODUCTS_FOR_ADD_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        productsForAddCollection: action.payload,
      }
      break
    case GET_PRODUCTS_FOR_ADD_COLLECTION_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        productsForAddCollection: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case GET_PRODUCT_OFFER_FOR_ADD_COLLECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productsForAddCollection: null,
        productsOfferForAddCollection: action.payload,
      }
      break
    case GET_PRODUCT_OFFER_FOR_ADD_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        productsOfferForAddCollection: action.payload,
      }
      break
    case GET_PRODUCTS_OFFER_FOR_ADD_COLLECTION_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break

    case REFRESH_COLLECTION_COUNT:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productsForAddCollection: null,
        productsOfferForAddCollection: action.payload,
      }
      break
    case REFRESH_COLLECTION_COUNT_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collection: state.collection.map(i =>
          i.id === action.payload.id ? action.payload : i
        ),
      }
      break
    case REFRESH_COLLECTION_COUNT_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
  }
  return state
}

export default collection
